var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.875C5.51269 1.875 1.875 5.51269 1.875 10C1.875 14.4873 5.51269 18.125 10 18.125C14.4873 18.125 18.125 14.4873 18.125 10C18.125 5.51269 14.4873 1.875 10 1.875ZM10 6.04167C10.3452 6.04167 10.625 6.32149 10.625 6.66667V9.375H13.3333C13.6785 9.375 13.9583 9.65482 13.9583 10C13.9583 10.3452 13.6785 10.625 13.3333 10.625H10.625V13.3333C10.625 13.6785 10.3452 13.9583 10 13.9583C9.65482 13.9583 9.375 13.6785 9.375 13.3333V10.625H6.66667C6.32149 10.625 6.04167 10.3452 6.04167 10C6.04167 9.65482 6.32149 9.375 6.66667 9.375H9.375V6.66667C9.375 6.32149 9.65482 6.04167 10 6.04167Z",
    fill: "#09D1D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.aa53872454c3ed7557b25d372fa0b6c7.svg";
export { ForwardRef as ReactComponent };